export const egp = (v) => {
  const n = Number(v || 0);
  const digits = Math.abs(n) < 1 && n !== 0 ? 4 : 2;
  return `${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: digits })} ج.م`;
};

export const egpShort = (v) =>
  `${Number(v || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })} ج.م`;

export const num = (v) => Number(v || 0).toLocaleString('en-US');

// Restrict phone input to digits and a single optional leading "+" (country code).
// Egyptian normalization: 10 digits starting with "1" (missing leading 0) → auto-prepend
// "0" so e.g. "1019379000" becomes "01019379000". Same idempotent normalization runs on
// the backend, so submitted values always land in canonical form.
export const sanitizeMobile = (v) => {
  let s = (v || '').replace(/[^\d+]/g, '');   // keep digits and "+"
  s = s.replace(/(?!^)\+/g, '');               // allow "+" only at the start
  s = s.slice(0, 16);
  // Egyptian mobile: exactly 10 digits starting with 1 → user forgot the leading 0.
  if (/^1\d{9}$/.test(s)) s = '0' + s;
  // "+20 01xxxxxxxxx" or "20 01xxxxxxxxx" typed with country code — collapse to 01xxxxxxxxx.
  if (/^\+?2001\d{9}$/.test(s)) s = s.replace(/^\+?20/, '');
  return s;
};

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleString('en-GB', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return '—';
  }
};

export const providerLabel = (p) => ({
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  gemini: 'Google',
}[p] || p);

export const providerColor = (p) => ({
  openai: 'text-emerald-600 bg-emerald-500/10 border-emerald-500/20',
  anthropic: 'text-orange-600 bg-orange-500/10 border-orange-500/20',
  gemini: 'text-blue-600 bg-blue-500/10 border-blue-500/20',
}[p] || 'text-primary bg-primary/10 border-primary/20');

// Reasoning / extended-thinking models spend part of the token budget on
// internal reasoning, so a small max_tokens can yield an empty reply. We flag
// Claude Opus (extended thinking) and OpenAI o-series (o3, o3-pro, o4-mini).
export const isReasoningModel = (id = '') => /opus/i.test(id) || /^o\d/i.test(id);

export const REASONING_HINT = 'موديل تفكير عميق: بيستهلك جزء من التوكنز في التفكير، فاستخدم max_tokens كافٍ (1000 أو أكثر) عشان متحصلش على رد فاضي.';

